import { useAsyncAction } from 'myHooks';
import { publicActions } from 'actions';

function useSupportedWallets() {
  const { value, error } = useAsyncAction(
    publicActions.getSupportedWallets,
    true
  );

  if (error) console.log(error);

  return value || [];
}

export default useSupportedWallets;
